export default "__VITE_ASSET__f5219285__"